export enum ReliabilityReportStatus {
  Open = 1,
  Reported = 2,
  Closed = 3,
}

export const ReliabilityReportStatusChoices = [
  { key: "OPEN", value: ReliabilityReportStatus.Open },
  { key: "CLOSED", value: ReliabilityReportStatus.Closed },
  { key: "REPORTED", value: ReliabilityReportStatus.Reported },
];
